import { ILSTable } from '@common/components';
import { tableEventDetailsTrackConfig } from '@common/table-configs/monitoring-event-details/track-table';
import { data2table } from '@common/table-configs/monitoring-event-details/track-table/decorators';
import { Dictionary } from '@common/types';
import { EventDetailsTab } from '@modules/monitoring/children/event-details/types';
import { FC } from 'react';
import { tablePropConfig } from '../../configs/table';
import { MonitoringEventDetailsStore } from '../../types/store';

interface Props {
  tab: EventDetailsTab;
  vehicleEvents: MonitoringEventDetailsStore['VehicleEvents'];
  tracks: MonitoringEventDetailsStore['VehicleTracks'];
  vehicleSensor: MonitoringEventDetailsStore['VehicleSensor'];
  decoratedData: ReturnType<typeof data2table>;
}

/**
 * Таблица детализации маршрута
 *
 */

export const DetailsTrackTableComponent: FC<Props> = ({ tab, vehicleSensor, tracks, vehicleEvents, decoratedData, ...props }) => {
  return (
    <div className={'position-relative h-100 catalog-item'}>
      <div className="ils-monitoring-details-detail-table position-relative">
        <ILSTable
          {...props}
          {...tablePropConfig}
          config={tableEventDetailsTrackConfig}
          dataSource={decoratedData}
          size={'small'}
          className="editable-table"
          bordered
          dictionary={Dictionary.EventDetailsTrack}
          tableName={Dictionary.EventDetailsTrack}
        />
      </div>
    </div>
  );
};
